<template>
    <div v-if="availableMerchandises.length > 0">

        <!-- All available merchandises -->
        <div class="checkout-accessories accessories-available">
            <div class="promo-text">
                <h4 class="block-title text-dark">Add Merch</h4>
            </div>
            <OwlCarousel class="accessories-items-container"
                         :responsive="{
                                0: {
                                    items: 1.1
                                },
                                500: {
                                    items: 2
                                },
                                900: {
                                    items: 3
                                },
                                1500: {
                                    items: 4.6
                                }
                         }"
                         :center="true"
                         :loop="false"
                         :nav="false"
                         :dots="false">
                <div v-for="merchandise in availableMerchandises" :key="merchandise.id" class="accessory-item" @click="addToCart(merchandise)" v-tooltip:top="'Add ' + merchandise.name">
                    <img :src="merchandise.image ? merchandise.image : '/assets/images/icons/no-image.png'" :alt="merchandise.name">
                    <span>{{ merchandise.name }}</span>
                </div>
            </OwlCarousel>
        </div>

        <!-- All merchandises in cart -->
        <div class="checkout-list">
            <div v-show="merchandises.length === 0" class="text-center">
                <h5 class="mt-5">No merch was added</h5>
            </div>
            <div v-for="(merchandise, index) in merchandises" :key="index" class="cart-item">
                <div class="cart-item-container">
                    <img class="item-image" :src="merchandise.item.image ? merchandise.item.image : '/assets/images/icons/no-image.png'" :alt="merchandise.item.name" :title="merchandise.item.name">
                    <div class="item-info">
                        <h4 class="title">{{ merchandise.item.name }}</h4>
                        <div class="dropdown">
                            <a href="#" class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">Size: {{ merchandise.priceOption.size }} ({{ merchandise.priceOption.price | filterPrice }})</a>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li v-for="price in merchandise.item.prices">
                                    <a class="dropdown-item" :class="{ disabled: !price.checked }" href="javascript:void(0);" @click="merchandise.priceOption = price">{{ price.size }} <template v-if="price.checked">({{ price.price | filterPrice }})</template></a>
                                </li>
                            </ul>
                        </div>
                        <a class="item-action-remove" href="javascript:void(0);" @click="removeMerchandise(index)">
                            <span class="bi bi-x-circle"></span> Remove
                        </a>
                    </div>
                    <div class="item-controls">
                        <NumberSelector :min="1" class="style-01" v-model="merchandise.amount" />
                        <h5 class="total">{{ (merchandise.priceOption.price * merchandise.amount) | filterPrice }}</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import OwlCarousel from "vue-owl-carousel";
import ApiRequest from "../../../../utils/api-request";
import {mapActions, mapGetters} from "vuex";
import SettingsMixin from "../../../../mixins/SettingsMixin";
import MerchandiseItem from "../../../../models/MerchandiseItem";

export default {
    name: "CheckoutMerchandises",
    mixins: [SettingsMixin],
    components: {
        OwlCarousel
    },
    data() {
        return {
            availableMerchandises: []
        }
    },
    computed: {
        ...mapGetters('cart', ['merchandises'])
    },
    watch: {
        // Listen changes (amount or time options)
        merchandises: {
            handler(value) {
                this.$store.commit('cart/SET_MERCHANDISES', value);
            },
            deep: true
        }
    },
    mounted() {
        new ApiRequest().getMerchandises(this.settings.locationId).then(
            (response) => {
                this.availableMerchandises = response.data.merchandises;
            }
        )
    },
    methods: {
        ...mapActions('cart', ['addMerchandise', 'removeMerchandise']),
        addToCart(merchandise) {
            this.addMerchandise(new MerchandiseItem(merchandise, 1, merchandise.prices[0]));
        },
        itemTotalPrice(accessory) {
            return accessory.priceOption.price * accessory.amount;
        }
    }
}
</script>

<style scoped>

</style>
